import { render, staticRenderFns } from "./LoginWrap.vue?vue&type=template&id=316a3e5d&scoped=true&"
import script from "./LoginWrap.vue?vue&type=script&lang=js&"
export * from "./LoginWrap.vue?vue&type=script&lang=js&"
import style0 from "./LoginWrap.vue?vue&type=style&index=0&id=316a3e5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316a3e5d",
  null
  
)

export default component.exports